"use strict";
exports.DIRECTION_BACK = 'back';
exports.DIRECTION_FORWARD = 'forward';
